import {
  SlateEditor,
  SlateElement,
  SlateTransforms,
  DomEditor,
} from "@wangeditor/editor";
import { ELEMENT_TYPE, MENU_KEY, MENU_NAME, MENU_ICON } from "../constants";
import Vue from "vue";
import Drop from "./drop.vue";
class menu {
  constructor() {
    this.title = MENU_NAME;
    this.iconSvg = MENU_ICON; // 在工具栏展示的图标，不设置图标会显示title
    this.tag = "button";
    this.showDropPanel = true;
    // this.showModal = true;
    this.$content = null;
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor) {
    return false;
  }

  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor) {
    return "";
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor) {
    return false;
  }
  // 点击菜单时触发的函数
  exec(editor) {}

  // 弹出框 modal 的定位：1. 返回某一个 SlateNode； 2. 返回 null （根据当前选区自动定位）
  getModalPositionNode(editor) {
    console.log("getModalPositionNode");
    return null; // modal 依据选区定位
  }
  getPanelContentElem(editor) {
    if (this.$content == null) {
      const contentBox = document.createElement("div");
      contentBox.classList.add("mark-drop-content");
      // 创建自定义组件实例
      const componentInstance = new (Vue.extend(Drop))({
        propsData: {
          editor: editor,
        },
      }).$mount();
      contentBox.appendChild(componentInstance.$el);
      this.$content = contentBox;
    } else {
      editor.emit("showMarkDrop");
    }
    const $content = this.$content;
    setTimeout(() => {
      const parentdom = $content.parentNode;
      parentdom.style.background = "transparent";
      parentdom.style.border = "none";
      parentdom.style.boxShadow = "unset";
    }, 10);
    return $content;
  }
}

// 自定义菜单配置
export const menuConfig = {
  key: MENU_KEY,
  factory() {
    return new menu();
  },
};
